<script>
  import {slide} from 'svelte/transition';
  import {quintOut} from 'svelte/easing';
  import {importantAnnouncement$} from './stream';

  let show = false;

  $: updateShow();

  function updateShow() {
    if (!process.browser) {
      return;
    }
    const nextTime = localStorage.getItem('home-announcement') || '0';
    const now = Date.now();
    const count = Math.floor((Number(nextTime) - now) / 1000);
    if (count < 0) {
      show = true;
      return;
    }
    show = false;
  }

  function handleClickClose() {
    show = false;
    const nextTime = Date.now() + 60000 * 60 * 12;
    localStorage.setItem('home-announcement', String(nextTime));
  }
</script>

<style>
  .announcements-wrap {
    padding: 20px 24px;
    background: #091723;
  }
  .announcements {
    margin: 0 auto;
    max-width: 1200px;
  }
  .title,
  .content {
    word-wrap: break-word;
    color: #fff;
  }
  .content:hover {
    opacity: 0.8;
  }
  .close {
    right: 0;
    top: 16px;
    width: 20px;
    background: rgba(0, 0, 0, 0.1);
    opacity: 0.6;
  }
  .close:hover {
    opacity: 1;
  }
  @media screen and (max-width: 640px) {
    .announcements-wrap {
      padding: 20px 16px;
      min-width: auto;
    }
  }
</style>

{#if $importantAnnouncement$ && show}
  <div transition:slide={{delay: 250, duration: 300, easing: quintOut}} class="announcements-wrap">
    <div class="announcements df pr">
      <div>
        <i class="iconfont f14 sell">&#xe802;</i>
      </div>
      <div class="ml16 mr24">
        <a href={$importantAnnouncement$.detail.webLink}>
          <div class="title fw2 f16 lh20">{$importantAnnouncement$.detail.title}</div>
          <div class="content mt10 f14 lh16">{$importantAnnouncement$.detail.content}</div>
        </a>
      </div>
      <div class="pa ml44 close df jcc aic" on:click={handleClickClose}>
        <i class="iconfont f18 cf cp">&#xe614;</i>
      </div>
    </div>
  </div>
{/if}
